import PropTypes from 'prop-types'
import React, { Component } from 'react'
import axios from 'axios'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

function sortJobs ({ jobs }) {
  return jobs.reduce((acc, job) => {
    job.departments.forEach(item => {
      if (acc[item.name]) {
        acc[item.name].push(job)
        return
      }

      acc[item.name] = [ job ]
    })

    return acc
  }, {})
}

const OpenPositionsBody = ({ departments, jobs }) => (
  <div className='open-positions--body'>
    {departments && departments.map((department, idx) => (
      <div key={idx} className='open-positions__dept-wrapper'>
        <div className='open-positions__department'>
          {department}
        </div>
        <ul className='open-positions__jobs'>
          {jobs[department] && jobs[department].map((job, idx) => (
            <li className='open-positions__job' key={idx}>
              <OutboundLink
                className='open-positions__job-link'
                href={job.absolute_url}
                target='_blank'
              >
                {job.title}
              </OutboundLink>
              <span>{job.location.name}</span>
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
)

OpenPositionsBody.propTypes = {
  departments: PropTypes.array,
  jobs: PropTypes.object
}

class OpenPositions extends Component {
  constructor (props) {
    super(props)

    this.state = {
      jobs: {}
    }
  }

  componentDidMount () {
    const endpoint = 'https://api.greenhouse.io/v1/boards/attn/embed/jobs?content=true'

    axios
      .get(endpoint)
      .then(res => {
        const sortedJobs = sortJobs(res.data)
        this.setState({
          jobs: sortedJobs
        })
      })
  }

  render () {
    const { jobs } = this.state
    const departments = Object.keys(jobs)

    return (
      <div className='open-positions'>
        <div className='wrapper--max-width'>
          <h2 className='open-positions__title'>Open Roles</h2>
          <OpenPositionsBody
            departments={departments}
            jobs={jobs}
          />
        </div>
      </div>
    )
  }
}

export default OpenPositions



// WEBPACK FOOTER //
// ./src/components/open-roles.js